import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-name-tag" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_TableList, {
      dataList: _ctx.list,
      columnAllData: _ctx.columnAllData,
      tableName: _ctx.TableName,
      permissionName: _ctx.permissionName,
      isShowPagination: false,
      canCommand: false,
      onCommandChange: _ctx.handleCommand,
      canRefresh: false,
      canChangeColumn: false,
      highlightCurrentRow: true
    }, {
      createUser: _withCtx(({ row }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formatUser(row)), 1)
      ]),
      _: 1
    }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "onCommandChange"])), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      class: "mt-20",
      total: _ctx.total,
      currentPage: _ctx.listQuery.page,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.page) = $event)),
      "page-size": _ctx.listQuery.size,
      "page-sizes": _ctx.pageSizes,
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      layout: "total, sizes, prev, pager, next"
    }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
      [_vShow, _ctx.total > 0]
    ])
  ]))
}